import { Stack } from '@mui/material';
import type { ReactNode } from 'react';

import { Card } from '@woovi/ui';

type PaymentContentProps = {
  withCard?: boolean;
  children: ReactNode;
};

const PaymentContent = ({
  withCard = true,
  children,
}: PaymentContentProps): ReactNode => {
  const getCardStyles = (): Record<string, unknown> => {
    if (withCard) {
      return {
        px: 3,
      };
    }

    return {
      border: 'none',
    };
  };

  const getContainerStyles = (): Record<string, unknown> => {
    if (withCard) {
      return {
        py: 2,
      };
    }

    return {};
  };

  return (
    <Card
      aria-label={'Payment Link Card'}
      sx={{
        display: 'flex',
        flexDirection: 'column',
        maxWidth: (theme) => theme.sizing.maxPaymentLinkWidth,
        width: '100%',
        ...getCardStyles(),
      }}
    >
      <Stack
        sx={{
          width: '100%',
          justifyContent: 'center',
          alignItems: 'center',
          gap: 2,
          flexDirection: 'column',
          ...getContainerStyles(),
        }}
      >
        {children}
      </Stack>
    </Card>
  );
};

export default PaymentContent;
